var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7902 0.290059C11.4002 -0.0999414 10.7702 -0.0999415 10.3802 0.290059L6.50022 4.17006L2.62022 0.290058C2.23022 -0.0999418 1.60022 -0.0999419 1.21022 0.290058C0.820221 0.680058 0.820221 1.31006 1.21022 1.70006L5.80022 6.29006C6.19022 6.68006 6.82022 6.68006 7.21022 6.29006L11.8002 1.70006C12.1802 1.32006 12.1802 0.680059 11.7902 0.290059Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.ed9a3ed208da4dc9fab5622caaa0922a.svg";
export { ForwardRef as ReactComponent };